// KIsult / Suritec cockpit: the dashboard is locked to the dark theme.
//
// Light/auto rendering has white-on-white contrast bugs in several upstream
// components-next surfaces (settings action icon-buttons, integration cards,
// report table headers): text/icon stays light while the surface uses the
// light-mode token, so content is invisible until hover. Dark mode renders all
// of these correctly and is the intended white-label aesthetic (orange on dark).
//
// The arg is kept for call-site compatibility (dashboard/App.vue, v3/App.vue)
// but intentionally ignored.
// eslint-disable-next-line no-unused-vars
export const setColorTheme = isOSOnDarkMode => {
  document.body.classList.add("dark");
  document.documentElement.style.setProperty("color-scheme", "dark");
};
